<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <template v-if="control.status == 'CURRENT'">
            <b v-if="!control.isHtmlContent">{{ control.valueContents }}</b>
            <b v-else v-html="control.valueContents" />
        </template>
        <template v-if="control.status == 'NEW'">
            <b v-if="!control.isHtmlContent" class="added">{{ control.valueContents }}</b>
            <b v-else v-html="control.valueContents" class="added"/>
        </template>
        <template v-if="control.status == 'UPDATE'">
            <ul>
                <li class="added">
                    <b v-if="!control.isHtmlContent" class="added">{{ getValue(control.valueContents, control.isHtmlContent) }}</b>
                    <b v-else v-html="getValue(control.valueContents, control.isHtmlContent)" class="added" />
                </li>
                <li class="deleted">
                    <b v-if="!control.isHtmlContent" class="deleted">{{ getValue(control.oldValueContents, control.isHtmlContent) }}</b>
                    <b v-else v-html="getValue(control.oldValueContents, control.isHtmlContent)" class="deleted" />
                </li>
            </ul>
        </template>
        <template v-else>
            <b v-if="!control.isHtmlContent" class="deleted">{{ control.oldValueContents }}</b>
            <b v-else v-html="control.oldValueContents" class="deleted"/>
        </template>
    </div>
</template>

<script>
import Utils from '@/common/utils'
export default {
    name: 'AuditNoteWithContent',

    props: {
        control: Object
    },

    methods: {
        getValue(str, isHtmlContent) {
            if (Utils.isNullOrEmptyString(str)) {
                if (isHtmlContent) {
                    return `<p>${this.$t('AuditList.Empty')}</p>`;
                } else {
                    return `${this.$t('AuditList.Empty')}`;
                }
            }

            return str;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red;
}
.added {
    color: green;
}
</style>